module.exports = __webpack_public_path__ + "media/packs/images/search/loading-fa98e23fb786269907eaa065787b9599.svg";